
const mustConfirm = (now, last, interval) => now > last + interval

export default user => !user.primaryEmailConfirmedAt || mustConfirm(
    new Date().getTime(), // now
    new Date(user.primaryEmailConfirmedAt).getTime(),
    6 * 7 * 24 * 60 * 60 * 1000 // 6 Weeks
  )



// WEBPACK FOOTER //
// ./src/app/utils/must-confirm.js